<template>
    <div class="selectZone">
        <label class="text-nowrap mt-2 mt-md-1 ml-0 ml-md-3 mb-1 mb-md-0"
               v-if="selectName">{{selectName}}</label>
        <div class="dropdown">
            <button type="button"
                    class="dropdown-toggle border rounded-pill d-flex justify-content-between"
                    role="button"
                    :disabled="disabled"
                    data-toggle="dropdown">
                <span class="dropdown__content">{{ value }}</span>
                <ChevronDownIcon class="float-right" />
            </button>

            <div class="dropdown-menu">
                <a class="dropdown-item"
                   v-for="item in selectOption"
                   :key="item.value"
                   @click="selectEvent(item)">{{ item.label }}</a>
            </div>
        </div>
    </div>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons';

export default {
    name: 'Select',
    components: {
        ChevronDownIcon,
    },
    props: {
        selectName: {
            type: String,
            require: true,
            default: '',
        },
        value: {
            type: String,
            require: true,
        },
        selectOption: {
            type: Array,
            require: true,
        },
        eventName: {
            type: String,
            require: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        selectEvent(val) {
            this.$emit('selectemit', val);
        }
    }
};
</script>
<style lang="scss" scoped>
.selectZone {
    position: relative;
    .dropdown-toggle {
        width: 100%;
        padding: 0.75rem 0.75rem 0 1rem;
        height: 3.125rem;
        background-color: #FFF;

        @include media-breakpoint-up(md) {
            padding: 0.3rem 0.75rem 0 1rem;
            height: 2.25rem;
            width: 18%;
            max-width: 180px;
            min-width: 147px;
        }
        &:disabled {
            opacity: 0.7;
        }
        .dropdown__content {
            font-size: 15px;
            line-height: 1.75;
        }
    }
    .dropdown-toggle::after {
        content: none;
        border: 0;
    }
    ::v-deep {
        .dropdown-menu.show {
            width: 100%;
            @include media-breakpoint-up(md) {
                width: auto;
            }
            .dropdown-item:hover {
                background-color: $secondary;
            }
            .dropdown-item:focus {
                background-color: $primary;
            }
        }
    }
}
</style>
